module.exports = __webpack_public_path__ + "img/way.812c462c.png";